import { DetailController } from 'controllers';
import { withMultiDetailSelectHOC } from 'shared/HOC';

const DetailsSelectButtons = withMultiDetailSelectHOC(DetailController.getDetails());
export default DetailsSelectButtons;
